import { RootState } from "../../../utils/types/root-state";

export const getOrdersState = (state: RootState) => state.orders;